import type { Feature } from "@unbox/api";

export const FEATURE_LABELS: Record<Feature, string> = {
  api: "API",
  assurance: "Assurance",
  insights: "Insights",
  explorer: "Explorer",
  veryLowVolume: "Very Low Volume",
  hideExplorers: "Hide Explorers",
  noAffiliateAuthorisation: "No Affiliate Authorisation",
  pastDueBanner: "Past Due Banner",
  reviewQueue: "Review Queue",
} as const;

export const ALL_FEATURES: Feature[] = [
  "api",
  "assurance",
  "explorer",
  "insights",
  "reviewQueue",
  "veryLowVolume",
  "hideExplorers",
  "noAffiliateAuthorisation",
  "pastDueBanner",
] as const;
